export { default as BanSolidIcon } from './BanSolidIcon';
